import { render, staticRenderFns } from "./TextLimageR.vue?vue&type=template&id=299aa576"
import script from "./TextLimageR.vue?vue&type=script&lang=js"
export * from "./TextLimageR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports